import React, { useState, useEffect, useCallback } from "react";
import "./../../../assets/css/purchase/form.css";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";
import DatePicker from "../../components/DatePicker";
import ApReportModal from "../../components/Modal/ApReportModal";

// Utils
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

const PayablesReport = () => {
  const [name, setName] = useState(null);
  const [searchCriteria, setSearchCriteria] = useState({
    fromDate: moment("2025-06-19").format("YYYY-MM-DD"),
    toDate: moment("2025-07-31").format("YYYY-MM-DD"),
    payStatus: "",
    payType: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [showApModal, setShowApModal] = useState(false);
  const [apDataList, setApDataList] = useState([]);
  const [creditorSelected, setCreditorSelected] = useState([]);
  const [payStatusList] = useState([
    { id: 1, name: "รอจ่าย" },
    { id: 2, name: "จ่ายแล้ว" },
    { id: 13, name: "ยกเลิก" },
  ]);
  const [payTypeList] = useState([
    { id: 1, name: "จ่ายตามใบรับ" },
    { id: 2, name: "จ่ายตามรายการ" },
    { id: 3, name: "จ่ายตามใบมัดจำ" },
    { id: 4, name: "จ่ายตามใบสั่งซื้อ (ล่วงหน้า)" },
    { id: 5, name: "จ่ายตามใบแจ้งซ่อม" },
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const [exportController, setExportController] = useState({
    exportToExcel: null,
    isExporting: false,
    hasData: false,
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("7. รายงานเจ้าหนี้ รายวัน");
    setSearchCriteria({
      fromDate: moment("2025-06-19").format("YYYY-MM-DD"),
      toDate: moment("2025-07-31").format("YYYY-MM-DD"),
      payStatus: "",
      payType: "",
    });
    setFilteredData([]);
    setCreditorSelected([]);
    setCurrentPage(1);
    setItemsPerPage(16);

    try {
      const creditorDataList = await getDataWithComp(
        "View_Set_AP",
        "ORDER By AP_Id ASC"
      );
      if (creditorDataList && creditorDataList.length > 0) {
        setApDataList(creditorDataList);
      }
    } catch (error) {
      console.error("Error loading creditor data:", error);
      getAlert("FAILED", "ไม่สามารถโหลดข้อมูลเจ้าหนี้ได้");
    }
  };

  const handleChangeDate = (value, name) => {
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleChangeCriteria = (e) => {
    const { name, value } = e.target;
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);

  const onRowSelectAp = (selectedAps) => {
    setCreditorSelected(selectedAps);
    handleApClose();
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);
      let query = "";
      if (searchCriteria.fromDate && searchCriteria.toDate) {
        query += `AND (CAST(Pay_Date AS DATE) BETWEEN '${searchCriteria.fromDate}' AND '${searchCriteria.toDate}') `;
      } else if (searchCriteria.fromDate) {
        query += `AND CAST(Pay_Date AS DATE) = '${searchCriteria.fromDate}' `;
      } else if (searchCriteria.toDate) {
        getAlert("WARNING", "กรุณาระบุวันที่เริ่มต้น");
        return;
      }
      if (creditorSelected.length > 0) {
        const apCodes = creditorSelected
          .map((ap) => `'${ap.AP_Code}'`)
          .join(",");
        query += `AND AP_Code IN (${apCodes}) `;
      }
      if (searchCriteria.payStatus) {
        query += `AND Pay_Status = ${searchCriteria.payStatus} `;
      }
      if (searchCriteria.payType) {
        query += `AND Pay_Type = ${searchCriteria.payType} `;
      }
      const companyId = window.localStorage.getItem("company") || 1;
      console.log("Company ID:", companyId);
      console.log(
        "Query:",
        `SELECT FORMAT(CAST(Pay_Date AS DATETIME), 'dd/MM/yyyy') AS Pay_Date, Pay_No, PayStatus_Name, Pay_TypeName, AP_Code, AP_Name, Total_Pay_NetTotal FROM API_0401_PAY_H WHERE Comp_Id = ${companyId} ${query} ORDER BY Pay_Date, Pay_No ASC`
      );
      const response = await getDataWithComp(
        "API_0401_PAY_H",
        query.trim() + " ORDER BY Pay_Date, Pay_No ASC",
        companyId
      );
      console.log("Response:", response);
      if (response && response.length > 0) {
        setFilteredData(response);
        getAlert("SUCCESS", `พบข้อมูล ${response.length} รายการ`);
      } else {
        setFilteredData([]);
        getAlert("INFO", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา");
      }
    } catch (error) {
      console.error("Search Error:", error);
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  const handleExportReady = useCallback((state) => {
    setExportController((prev) => {
      if (
        prev.exportToExcel === state.exportToExcel &&
        prev.isExporting === state.isExporting &&
        prev.hasData === state.hasData
      ) {
        return prev;
      }
      return state;
    });
  }, []);

  const handleExportClick = useCallback(() => {
    if (exportController?.exportToExcel) {
      exportController.exportToExcel();
    } else {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
    }
  }, [exportController]);

  const selectedCreditorsDisplay = creditorSelected
    .map((ap) => `${ap.AP_Code} - ${ap.AP_Name}`)
    .join(", ");

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/payables-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="row g-3 align-items-end">
                      <div className="col-md-2">
                        <label htmlFor="fromDate" className="form-label">
                          วันที่
                        </label>
                        <DatePicker
                          label=""
                          name="fromDate"
                          value={searchCriteria.fromDate}
                          onChange={(date) =>
                            handleChangeDate(date, "fromDate")
                          }
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="toDate" className="form-label">
                          ถึงวันที่
                        </label>
                        <DatePicker
                          label=""
                          name="toDate"
                          value={searchCriteria.toDate}
                          onChange={(date) => handleChangeDate(date, "toDate")}
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">เจ้าหนี้</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-spacing"
                            value={selectedCreditorsDisplay || ""}
                            disabled={true}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleApShow();
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="payStatus" className="form-label">
                          ประเภท
                        </label>
                        <select
                          className="form-select form-control input-spacing"
                          id="payStatus"
                          name="payStatus"
                          value={searchCriteria.payStatus || ""}
                          onChange={handleChangeCriteria}
                        >
                          <option value="">ทั้งหมด</option>
                          {payStatusList.map((status) => (
                            <option key={status.id} value={status.id}>
                              {status.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="payType" className="form-label">
                          ประเภทการจ่าย
                        </label>
                        <select
                          className="form-select form-control input-spacing"
                          id="payType"
                          name="payType"
                          value={searchCriteria.payType || ""}
                          onChange={handleChangeCriteria}
                        >
                          <option value="">ทั้งหมด</option>
                          {payTypeList.map((type) => (
                            <option key={type.id} value={type.id}>
                              {type.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white me-2"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            minWidth: "150px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white me-2"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            minWidth: "150px",
                          }}
                          onClick={handleExportClick}
                          disabled={!exportController.hasData || exportController.isExporting}
                        >
                          <i className="fas fa-file-excel" />{" "}
                          {exportController.isExporting ? "กำลังส่งออก..." : "Export"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            minWidth: "150px",
                          }}
                          onClick={() => initialize()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ApReportModal
                showApModal={showApModal}
                handleApClose={handleApClose}
                apDataList={apDataList}
                onRowSelectAp={onRowSelectAp}
              />
              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                setCurrentPage={setCurrentPage}
                fieldMappings={{
                  payDate: "Pay_Date",
                  payNo: "Pay_No",
                  payStatusName: "PayStatus_Name",
                  payTypeName: "Pay_TypeName",
                  apCode: "AP_Code",
                  apName: "AP_Name",
                  netTotal: "Total_Pay_NetTotal",
                }}
                onExportReady={handleExportReady}
                showExportButton={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayablesReport;
